var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144.4 24.1",
    style: {
      enableBackground: "new 0 0 144.4 24.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 100.5,
    className: "st0",
    width: 4.2,
    height: 23.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.1,
    y: 7.2,
    className: "st0",
    width: 4.2,
    height: 16.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.7,
    y: 13.1,
    className: "st0",
    width: 4.2,
    height: 10.6
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,7.6h7.4c3.1,0,5.2,1.8,5.2,4.5c0,1.9-0.9,3.3-3,3.9V16c1.5,0.4,2.3,1.3,2.5,3.3c0.2,2.3,0.1,4,0.7,4.3v0.2 H9.7c-0.4-0.2-0.5-2-0.6-3.7c-0.1-1.8-1.1-2.8-3.2-2.8H3.3v6.5H0V7.6z M3.3,14.7h3.5c1.8,0,2.7-0.9,2.7-2.2c0-1.3-0.8-2.3-2.6-2.3 H3.3V14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.5,17.9c0-3.5,2.5-6.1,6.1-6.1s6.1,2.7,6.1,6.1s-2.5,6.1-6.1,6.1S13.5,21.4,13.5,17.9z M22.5,17.9 c0-2.3-1.1-3.8-2.9-3.8c-1.9,0-2.9,1.5-2.9,3.8s1,3.8,2.9,3.8C21.5,21.7,22.5,20.2,22.5,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.3,20h2.8c0.2,1.3,1.2,1.9,2.5,1.9c1.4,0,2.1-0.5,2.1-1.3c0-1.1-1.5-1.2-3-1.5c-2.1-0.4-4.1-1-4.1-3.5 c0-2.5,2.1-3.7,4.7-3.7c3,0,4.7,1.5,5,3.8h-2.8c-0.1-1.2-0.9-1.7-2.2-1.7c-1.2,0-2,0.5-2,1.3c0,1,1.5,1.1,3.2,1.4 c1.9,0.4,4.1,0.9,4.1,3.7c0,2.3-2,3.7-4.9,3.7C28.4,24.1,26.5,22.4,26.3,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.1,13.6L41.1,13.6c0.9-1.2,1.9-1.8,3.4-1.8c2.4,0,4,1.8,4,4.3v7.6h-3.1v-7.1c0-1.2-0.7-2.1-2-2.1 c-1.4,0-2.3,1.1-2.3,2.7v6.6H38V7.6h3.1V13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.8,17.9c0-3.5,2.5-6.1,6.1-6.1c3.6,0,6.1,2.7,6.1,6.1s-2.5,6.1-6.1,6.1C52.3,24.1,49.8,21.4,49.8,17.9z  M58.8,17.9c0-2.3-1.1-3.8-2.9-3.8c-1.9,0-2.9,1.5-2.9,3.8s1,3.8,2.9,3.8C57.8,21.7,58.8,20.2,58.8,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.4,7.6h3.1v16.1h-3.1V7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.5,12.1h3v1.6h0.1c0.6-1.1,1.8-1.9,3.4-1.9c1.5,0,2.6,0.8,3.2,2h0c0.8-1.3,2-2,3.5-2c2.4,0,3.8,1.6,3.8,4.1 v7.8h-3.1v-7.3c0-1.3-0.7-2-1.8-2c-1.3,0-2.1,1-2.1,2.5v6.7h-3.1v-7.3c0-1.3-0.7-2-1.8-2c-1.2,0-2.1,1-2.1,2.5v6.7h-3.1V12.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M108.9,7.6h6.3c4.3,0,7.1,3.5,7.1,8.2c0,2.6-0.9,4.9-2.6,6.3c-1.2,1-2.8,1.6-4.8,1.6h-6V7.6z M114.7,20.9 c3.1,0,4.3-1.9,4.3-5.1s-1.4-5.4-4.2-5.4h-2.6v10.5H114.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.3,17.9c0-3.4,2.3-6.1,5.7-6.1c3.7,0,5.7,2.8,5.7,7h-8.4c0.2,1.8,1.2,2.9,3,2.9c1.2,0,1.9-0.5,2.2-1.4h3 c-0.4,2.1-2.3,3.8-5.2,3.8C125.4,24.1,123.3,21.4,123.3,17.9z M126.3,16.7h5.1c-0.1-1.5-1.1-2.5-2.5-2.5 C127.4,14.2,126.6,15.2,126.3,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.2,7.6h3.1v16.1h-3.1V7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.3,7.6h3.1v16.1h-3.1V7.6z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logoWhite.52aed3e7bfe5e848ba8b9e8c78fcaa47.svg";
export { ForwardRef as ReactComponent };